import { PurposeEnum } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { IoIosArrowDown } from "react-icons/io";

export default function PurposeSelectorServer({
  t,
  purpose,
}: {
  t: any;
  purpose: PurposeEnum;
}) {
  return (
    <div className={`${styles.selectWrapper} ${styles.typeItemWrapper}`}>
      <button className={styles.pill}>
        <div className={styles.textWrapper}>
          <span>{t(purpose)}</span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
    </div>
  );
}
